import React, {useState} from 'react'
import ReactPaginate from "react-paginate";
import css from './pagination.module.scss'


export const Pagination = ({total=10, currentPage=0, setCurrentPage=() => {}}) => {
    const handlePageChange = (selected) => {
      setCurrentPage(selected.selected);
    };


    return (
        <div>
            <ReactPaginate
                previousLabel={<span><i className='fas fa-chevron-left' /></span>}
                nextLabel={<span><i className='fas fa-chevron-right' /></span>}
                breakLabel={"..."}
                breakClassName={css.breakMe}
                pageCount={Math.ceil(total)} // Total number of pages
                marginPagesDisplayed={1}
                pageRangeDisplayed={3}
                onPageChange={handlePageChange}
                containerClassName={css.pagination}
                subContainerClassName={`${css.pages} ${css.pagination}`}
                activeClassName={css.active}
                initialPage={currentPage}
                forcePage={currentPage}
            />
        </div>
    )
}